import {trackEventSP} from 'js/studios/shared/tracking'

export function AltCategoryCta() {
  const URL_MAPPINGS = {
    wedding_band_set: "/custom-wedding-rings/",
    necklace: "/custom-necklaces/",
    signet_ring: "/custom-signet-rings/",
    class_ring: "/custom-class-rings/",
    earrings: "/custom-earrings/",
    cufflinks: "/custom-cufflinks/",
    other_ring: "/custom-rings/"
  }

  const IMAGE_MAPPINGS = {
    wedding_band_set: `${window.cm.structureUrl}/static/images/brand2025/landing/alt-cat-wedding-band.jpg`,
    necklace: `${window.cm.structureUrl}/static/images/brand2025/landing/alt-cat-pendants.jpg`,
    signet_ring: `${window.cm.structureUrl}/static/images/brand2025/landing/alt-cat-signet.jpg`,
    class_ring: `${window.cm.structureUrl}/static/images/brand2025/landing/alt-cat-class.jpg`,
    earrings: `${window.cm.structureUrl}/static/images/brand2025/landing/alt-cat-earrings.jpg`,
    cufflinks: `${window.cm.structureUrl}/static/images/brand2025/landing/alt-cat-cufflinks.jpg`,
    other_ring: `${window.cm.structureUrl}/static/images/brand2025/landing/alt-cat-statement.jpg`
  }

  const ALTTEXT_MAPPINGS = {
    wedding_band_set: "Rose gold wedding band",
    necklace: "Moonstone necklace",
    signet_ring: "Gold family crest signet ring",
    class_ring: "Gold class ring",
    earrings: "Gold clover and heart earrings",
    cufflinks: "Coat of arms cufflinks",
    other_ring: "Filigree statement ring"
  }

  const selectNode = document.getElementById('alternate-category-select-field')
  const learnMoreBtn = document.getElementById('alternate-category-select-submit')
  const startOtherLink = document.getElementById('start-other-jewelry-project')
  const altCatImg = document.getElementById('alt-category-image')

  selectNode.addEventListener('change', function(ev) {
    if (ev.target.value) {
      Array.from(document.querySelectorAll('.alternate-categories-form .btn')).forEach(n => {
        n.classList.add('active')
      })
      startOtherLink.setAttribute('href', `/design-with-us/?category=${ev.target.value}`)
      altCatImg.setAttribute("src", IMAGE_MAPPINGS[ev.target.value])
      altCatImg.setAttribute("alt", ALTTEXT_MAPPINGS[ev.target.value])
    } else {
      Array.from(document.querySelectorAll('.alternate-categories-form .btn')).forEach(n => {
        n.classList.remove('active')
      })
    }
  })

  learnMoreBtn.addEventListener('click', function(ev) {
    ev.preventDefault()
    if (selectNode.value?.length > 1) {
      trackEventSP('click_body_link', 'browse', { label: `Learn More: ${URL_MAPPINGS[selectNode.value]}` })
      window.location.href = URL_MAPPINGS[selectNode.value]
    }
  })
}
